import { EditProfileModel } from './../models/user/editProfileModel';
import { ChangePasswordModel } from './../models/user/changePasswordModel';
import axios from 'axios';
import * as Constants from "../common/constants";
import AuthService from './authService';
import * as HelperFunctions from '../common/functions/helperFunctions';
import { UserFilterSettingsModel } from "../models/user/userFilterSettingsModel";
import { UserModel } from '../models/user';

class UserService {
  authService = new AuthService();

  constructor() {
    axios.defaults.baseURL = `${Constants.apiUrl}/`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Authorization: `Bearer ${this.authService.getToken()}`,
      Pragma: 'no-cache'
    }
  }

  getAllUsers(from: number, numberOfRows: number, settings: UserFilterSettingsModel) {
    return axios({
      url: `users/getAll/${from}/${numberOfRows}`,
      method: 'post', headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(settings)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getUsersByRegionAndRole(regionId?: number, roleId?: number) {
    if (!regionId)
      regionId = 0;

    if (!roleId)
      roleId = 0;

    return axios({
      url: `users/getUsersRegionRole/${regionId}/${roleId}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getUser(id: number) {
    return axios({
      url: `users/getById/${id}`,
      method: 'get'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  addUser(user: UserModel) {
    return axios({
      url: `users/create`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(user)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  editUser(user: UserModel) {
    return axios({
      url: `users/update`,
      method: 'put',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(user)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  deleteUser(id: number) {
    return axios({
      url: `users/delete/${id}`,
      method: 'delete'
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  changePassword(changePasswordModel: ChangePasswordModel) {
    return axios({
      url: `users/changePassword`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(changePasswordModel)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  editProfile(editProfileModel: EditProfileModel) {
    return axios({
      url: `users/editProfile`,
      method: 'post',
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      data: JSON.stringify(editProfileModel)
    })
      .then(res => res.data.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default UserService;
